"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetUserTeamProperties = exports.getOooSettingsQuery = exports.useGetTeamPropertyQuery = exports.useGetTeamRequestLimitQuery = exports.useGetTeamUsersQuery = exports.getTeamUsersQuery = exports.useGetCurrentTeamQuery = exports.getDecoratedUserQuery = exports.useGetTeamQuery = exports.teamQuery = exports.teamsQuery = exports.useGetAllTeamsQuery = exports.allTeamsQuery = exports.selectedTeamIdQuery = exports.useRemoveUserFromTeamQuery = exports.useDeActivateTeamQuery = exports.useActivateTeamQuery = exports.useSetUserTeamPropertyQuery = exports.useSaveTeamPropertyQuery = exports.useSetCurrentTeamByIdQuery = exports.useSaveTeamNameQuery = exports.useCreateTeamQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const appConstants_1 = require("../constants/appConstants");
const teamRepository_1 = require("../repositories/teamRepository");
const userSettingRepository_1 = require("../repositories/userSettingRepository");
const Root_1 = require("../router/Root");
const userSelectors_1 = require("../selectors/userSelectors");
const setTime_1 = require("../utils/setTime");
const zustandStore_1 = require("../zustandStore");
const paymentQuery_1 = require("./paymentQuery");
const query_keys_1 = require("./query-keys");
const userQuery_1 = require("./userQuery");
const logger = (0, pino_1.default)();
const useCreateTeamQuery = () => {
    const { setTeamId } = (0, zustandStore_1.useZustand)();
    return (0, react_query_1.useMutation)({
        mutationFn: teamRepository_1.TeamRepository.createTeam,
        onSuccess: data => {
            setTeamId(data?.teamId);
            return Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.teamKeys.getTeam] });
        },
    });
};
exports.useCreateTeamQuery = useCreateTeamQuery;
const useSaveTeamNameQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: teamRepository_1.TeamRepository.saveTeamName,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.teamKeys.getTeam] });
        },
    });
};
exports.useSaveTeamNameQuery = useSaveTeamNameQuery;
const useSetCurrentTeamByIdQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: userSettingRepository_1.UserSettingRepository.saveUserSetting,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.userKeys.getUserSettings, 'settingName'] });
        },
    });
};
exports.useSetCurrentTeamByIdQuery = useSetCurrentTeamByIdQuery;
const useSaveTeamPropertyQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: teamRepository_1.TeamRepository.saveTeamProperty,
        onSuccess: async () => {
            void Root_1.queryClient.invalidateQueries({ queryKey: query_keys_1.teamKeys.getTeams({}) });
            void Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.teamKeys.getTeamProperty] });
            void Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.teamKeys.getSelectedTeamProperty] });
        },
    });
};
exports.useSaveTeamPropertyQuery = useSaveTeamPropertyQuery;
const useSetUserTeamPropertyQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: ({ userId, teamId, propertyKey, propertyValue }) => teamRepository_1.TeamRepository.setUserTeamProperty(userId, teamId, propertyKey, propertyValue),
        onSuccess: async () => {
            await Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.teamKeys.getTeamProperty] });
            await Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.teamKeys.getTeamUsers],
            });
            return Root_1.queryClient.invalidateQueries({
                queryKey: [paymentQuery_1.paymentKeys.getTeamApprovers],
            });
        },
    });
};
exports.useSetUserTeamPropertyQuery = useSetUserTeamPropertyQuery;
const useActivateTeamQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: teamRepository_1.TeamRepository.activateTeam,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({ queryKey: query_keys_1.teamKeys.getTeams({}) });
        },
    });
};
exports.useActivateTeamQuery = useActivateTeamQuery;
const useDeActivateTeamQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: teamRepository_1.TeamRepository.deactivateTeam,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({ queryKey: query_keys_1.teamKeys.getTeams({}) });
        },
    });
};
exports.useDeActivateTeamQuery = useDeActivateTeamQuery;
const useRemoveUserFromTeamQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: async ({ userId, teamId }) => {
            return teamRepository_1.TeamRepository.removeUserFromTeam(teamId, userId);
        },
        onSuccess: async (_data, variables) => {
            await Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.teamKeys.getTeamUsers] });
            await Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.teamKeys.getDecoratedUser, { teamId: variables.teamId, userId: variables.userId }],
            });
        },
    });
};
exports.useRemoveUserFromTeamQuery = useRemoveUserFromTeamQuery;
async function getActiveTeamIdOrFallback(activeTeams, fallbackData) {
    if (!activeTeams?.length) {
        return fallbackData;
    }
    const activeTeam = activeTeams.find(team => team.state === 'ACTIVE');
    if (activeTeam) {
        await userSettingRepository_1.UserSettingRepository.saveUserSetting({ selectedTeamID: activeTeam.id });
        return [activeTeam.id];
    }
    return fallbackData;
}
async function geCurrentSelectedTeamIdOrTheFirstIdFormAnActiveTeam(settingName) {
    let selectedTeamIdData = [];
    try {
        const data = await userSettingRepository_1.UserSettingRepository.getUserSettings(settingName);
        if (settingName !== 'selectedTeamID') {
            return data;
        }
        selectedTeamIdData = data;
    }
    catch (error) {
        logger.error(error);
        selectedTeamIdData = [];
    }
    const user = await Root_1.queryClient.ensureQueryData(userQuery_1.userQuery);
    const isUserTsSupport = (0, userSelectors_1.isSupportAdmin)(user?.roles ?? []);
    if (isUserTsSupport) {
        // first try to get the current active selected team id
        try {
            const teamId = selectedTeamIdData?.[0] ?? '';
            const team = await Root_1.queryClient.ensureQueryData((0, exports.teamQuery)({ teamId }));
            if (team.state === 'ACTIVE') {
                return [team?.id];
            }
            throw new Error(`No active team with id ${team?.id} found`);
        }
        catch {
            const activeTeams = await Root_1.queryClient.ensureQueryData((0, exports.teamsQuery)({ state: 'active' }));
            return getActiveTeamIdOrFallback(activeTeams, selectedTeamIdData);
        }
    }
    const teamId = selectedTeamIdData?.[0] ?? '';
    const team = await Root_1.queryClient.ensureQueryData((0, exports.teamQuery)({ teamId }));
    if (team.state === 'ACTIVE') {
        return selectedTeamIdData;
    }
    const teamData = await Root_1.queryClient.ensureQueryData((0, exports.teamsQuery)({ state: 'active' }));
    return getActiveTeamIdOrFallback(teamData, selectedTeamIdData);
}
const selectedTeamIdQuery = (settingName) => {
    return (0, react_query_1.queryOptions)({
        queryKey: [query_keys_1.userKeys.getUserSettings, settingName],
        queryFn: () => geCurrentSelectedTeamIdOrTheFirstIdFormAnActiveTeam(settingName),
        staleTime: (0, setTime_1.setTime)(10, 'seconds'),
    });
};
exports.selectedTeamIdQuery = selectedTeamIdQuery;
exports.allTeamsQuery = (0, react_query_1.queryOptions)({
    queryKey: query_keys_1.teamKeys.getAllTeams(),
    queryFn: teamRepository_1.TeamRepository.getAllTeams,
});
const useGetAllTeamsQuery = () => {
    return (0, react_query_1.useQuery)(exports.allTeamsQuery);
};
exports.useGetAllTeamsQuery = useGetAllTeamsQuery;
const teamsQuery = ({ state = 'active', limit, offset } = { offset: null, limit: null }) => {
    return (0, react_query_1.queryOptions)({
        queryKey: query_keys_1.teamKeys.getTeams({ state, limit, offset }),
        queryFn: () => teamRepository_1.TeamRepository.getTeamsPage({ state, limit, offset }),
        enabled: Boolean(state),
    });
};
exports.teamsQuery = teamsQuery;
const teamQuery = ({ teamId }) => (0, react_query_1.queryOptions)({
    queryKey: [query_keys_1.teamKeys.getTeam, { teamId }],
    queryFn: () => teamRepository_1.TeamRepository.getTeam({ teamId }),
    enabled: !!teamId,
});
exports.teamQuery = teamQuery;
const useGetTeamQuery = ({ teamId }) => (0, react_query_1.useQuery)((0, exports.teamQuery)({ teamId }));
exports.useGetTeamQuery = useGetTeamQuery;
const getDecoratedUserQuery = ({ teamId, userId, isEnabled = true }) => (0, react_query_1.queryOptions)({
    queryKey: [query_keys_1.teamKeys.getDecoratedUser, { teamId, userId }],
    queryFn: () => teamRepository_1.TeamRepository.getDecoratedUser({ teamId, userId }),
    enabled: isEnabled && Boolean(teamId && userId),
});
exports.getDecoratedUserQuery = getDecoratedUserQuery;
/* deprecated use currentTeamQuery instead */
const useGetCurrentTeamQuery = (existingTeams, teamId) => {
    const [teamQuery, teamsQuery] = (0, react_query_1.useQueries)({
        queries: [
            {
                queryKey: [query_keys_1.teamKeys.getTeam, { teamId }],
                queryFn: () => teamRepository_1.TeamRepository.getTeam({ teamId: teamId || '' }),
                enabled: Array.isArray(teamId) && Boolean(teamId?.[0]),
            },
            {
                queryKey: query_keys_1.teamKeys.getTeams({ state: 'active' }),
                queryFn: () => teamRepository_1.TeamRepository.getTeams({ state: 'active', limit: 10, page: 0 }),
                enabled: Array.isArray(existingTeams) && existingTeams.length === 0 && !teamId,
            },
        ],
    });
    if (teamQuery.isLoading || teamsQuery.isLoading) {
        return { data: null, isLoading: true };
    }
    if (teamQuery.error || teamsQuery.error) {
        return { data: null, error: teamQuery.error || teamsQuery.error, isLoading: false };
    }
    if (!lodash_1.default.isEmpty(teamQuery.data)) {
        return { data: teamQuery.data, isLoading: false };
    }
    else if (Array.isArray(existingTeams) && existingTeams.length > 0) {
        return { data: existingTeams[0], isLoading: false };
    }
    else if (!lodash_1.default.isEmpty(teamsQuery.data)) {
        return {
            data: teamsQuery.data?.[0] || {},
            isLoading: false,
        };
    }
    return {
        data: teamsQuery.data?.[0] || {},
        isLoading: false,
    };
};
exports.useGetCurrentTeamQuery = useGetCurrentTeamQuery;
const getTeamUsersQuery = ({ teamId, query = '' }) => {
    return (0, react_query_1.queryOptions)({
        queryKey: [query_keys_1.teamKeys.getTeamUsers, teamId, query],
        queryFn: () => teamRepository_1.TeamRepository.getTeamUsers(teamId, query),
        enabled: !!teamId,
    });
};
exports.getTeamUsersQuery = getTeamUsersQuery;
const useGetTeamUsersQuery = ({ limit = 10, page = 1, teamId, searchParam = '' }) => {
    let query = '?';
    query = query + `limit=${limit}`;
    query = query + `&page=${page}`;
    if (searchParam) {
        query = query + `&searchParam=${searchParam}`;
    }
    const queryInfo = (0, exports.getTeamUsersQuery)({ teamId, query });
    return (0, react_query_1.useQuery)({
        ...queryInfo,
        enabled: Boolean(teamId),
    });
};
exports.useGetTeamUsersQuery = useGetTeamUsersQuery;
const useGetTeamRequestLimitQuery = (teamId) => {
    return (0, react_query_1.useQuery)({
        queryKey: [
            query_keys_1.teamKeys.getTeamProperty,
            {
                teamId,
                propertyKey: appConstants_1.teamFeaturesConstants.requestLimit,
            },
        ],
        queryFn: () => teamRepository_1.TeamRepository.getTeamProperty({
            teamId,
            propertyKey: appConstants_1.teamFeaturesConstants.requestLimit,
        }),
        enabled: !!teamId,
    });
};
exports.useGetTeamRequestLimitQuery = useGetTeamRequestLimitQuery;
const useGetTeamPropertyQuery = teamId => {
    const { setSelectedTeamProperty } = (0, zustandStore_1.useZustand)();
    return (0, react_query_1.useQuery)({
        queryKey: [query_keys_1.teamKeys.getSelectedTeamProperty, teamId, appConstants_1.teamFeaturesConstants.pauseVirtualCardCreation],
        queryFn: async () => {
            const result = await teamRepository_1.TeamRepository.getTeamProperty({
                teamId,
                propertyKey: appConstants_1.teamFeaturesConstants.pauseVirtualCardCreation,
            });
            setSelectedTeamProperty(result ? 'true' : 'false');
            return result ? 'true' : 'false';
        },
        enabled: Boolean(teamId),
    });
};
exports.useGetTeamPropertyQuery = useGetTeamPropertyQuery;
const getOooSettingsQuery = ({ teamId, userId }) => ({
    queryKey: [query_keys_1.teamKeys.getOooSettings(teamId, userId)],
    queryFn: () => teamRepository_1.TeamRepository.getOooSettings({ teamId, userId }),
    enabled: Boolean(teamId),
});
exports.getOooSettingsQuery = getOooSettingsQuery;
const useSetUserTeamProperties = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: ({ settings, teamId, userId, }) => teamRepository_1.TeamRepository.setUserTeamProperties({
            properties: settings,
            teamId,
            userId,
        }),
    });
};
exports.useSetUserTeamProperties = useSetUserTeamProperties;
